export var UploadType;
(function (UploadType) {
    UploadType["CompanyLogos"] = "CompanyLogos";
    UploadType["FirmLogos"] = "FirmLogos";
    UploadType["UserImages"] = "UserImages";
    UploadType["FundDocuments"] = "FundDocuments";
    UploadType["ReportingAttachments"] = "ReportingAttachments";
    UploadType["WithdrawalAttachments"] = "WithdrawalAttachments";
    UploadType["InvestorIdvCertificates"] = "InvestorIdvCertificates";
    UploadType["EisCertificates"] = "EisCertificates";
    UploadType["PdfUpdates"] = "PdfUpdates";
    UploadType["KycDocuments"] = "KycDocuments";
    UploadType["FirmDocuments"] = "FirmDocuments";
    UploadType["PdfExitStatement"] = "PdfExitStatement";
    UploadType["CustomUpdateAttachments"] = "CustomUpdateAttachments";
    UploadType["BackgroundExports"] = "BackgroundExports";
    UploadType["LpTransactionAttachments"] = "LpTransactionAttachments";
    UploadType["LpBankStatements"] = "LpBankStatements";
    UploadType["InterestPayments"] = "InterestPayments";
    UploadType["InterestPaymentsWriteOutput"] = "InterestPaymentsWriteOutput";
    UploadType["DeploymentUpdateAttachments"] = "DeploymentUpdateAttachments";
    UploadType["DataRoomDocuments"] = "DataRoomDocuments";
    UploadType["InvestorClassificationDocuments"] = "InvestorClassificationDocuments";
    UploadType["VehicleSigningDocuments"] = "VehicleSigningDocuments";
    UploadType["OnboardingCustomRequestDocuments"] = "OnboardingCustomRequestDocuments";
    UploadType["InvestorTaxDocuments"] = "InvestorTaxDocuments";
    UploadType["CommitmentDocuments"] = "CommitmentDocuments";
    UploadType["CapitalActionNotices"] = "CapitalActionNotices";
    UploadType["LpInvestorUpdates"] = "LpInvestorUpdates";
    UploadType["LpPortfolioCompanyUpdates"] = "LpPortfolioCompanyUpdates";
    UploadType["LpBulletinUpdateAttachments"] = "LpBulletinUpdateAttachments";
})(UploadType || (UploadType = {}));
//# sourceMappingURL=index.js.map